<template>
  <div
    class="user-avatar">
    <img
      v-if="user.avatar"
      :src="user.avatar"
      class="user-avatar__img img-fluid rounded-circle"
      :class="size">
    <b-avatar 
      v-else
      class="user-avatar__img"
      :class="size"
      :text="user.name | initial" />
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'md'
    }
  }
}
</script>

<style lang="scss" scoped>
.user-avatar {
  &__img {
    width: 40px;
    min-width: 40px;
    height: 40px;
    object-fit: cover;
    font-size: 16px;

    &.sm {
      width: 30px;
      min-width: 30px;
      height: 30px;
      font-size: 12px;
    }

    &.lg {
      width: 60px;
      min-width: 60px;
      height: 60px;
      font-size: 16px;
    }
  }
}
</style>